import Seo from "../components/Seo.tsx";
import Divider from "../components/ornaments/Divider.tsx";

const values = [
  "Vegan Wax",
  "Small Batch",
  "Eco Packaging",
  "No Toxins",
];

const process = [
  {
    num: "01",
    title: "Source",
    body: "We source only the finest natural vegan wax and premium fragrance oils from trusted, ethical suppliers.",
  },
  {
    num: "02",
    title: "Blend",
    body: "Fragrances are carefully blended to create signature scents with depth, balance, and true longevity.",
  },
  {
    num: "03",
    title: "Pour",
    body: "Each candle is hand-poured at the perfect temperature for a smooth, even finish and exceptional scent throw.",
  },
  {
    num: "04",
    title: "Cure",
    body: "Candles cure for 48 hours minimum before being carefully inspected, labelled, and packed with love.",
  },
];

export default function Craft() {
  return (
    <div>
      <Seo
        title="Our Craft — The BeAdoré Process"
        description="Hand-poured in small batches from 100% vegan wax. Learn about BeAdoré's four-step craft process and our commitment to quality."
        path="/craft"
      />
      <section className="mx-auto max-w-4xl px-6 pt-24 pb-12 text-center md:px-10 md:pt-32">
        <span className="eyebrow">Our Story</span>
        <h1 className="mt-6 font-serif text-5xl leading-[1.05] text-[var(--color-emerald-deep)] md:text-7xl">
          Born from a love of craft{" "}
          <em className="font-serif italic text-[var(--color-amber)]">
            & nature.
          </em>
        </h1>
        <p className="mx-auto mt-10 max-w-2xl text-base leading-[1.85] font-light text-[var(--color-stone)]">
          BeAdoré was created with one simple belief — a candle is more than
          light. It's an atmosphere, a memory, a ritual. We hand-pour every
          candle in small batches using only plant-based vegan wax and
          carefully curated fragrance blends that honour both your senses and
          the earth.
        </p>

        <div className="mt-12 flex flex-wrap justify-center gap-3">
          {values.map((v) => (
            <span
              key={v}
              className="rounded-full border border-[var(--color-sage-light)] px-5 py-2 text-[0.7rem] font-medium uppercase tracking-[0.12em] text-[var(--color-emerald)]"
            >
              {v}
            </span>
          ))}
        </div>

        <p className="mt-14 font-serif text-2xl italic text-[var(--color-stone)]">
          "Every scent unlocks a memory."
        </p>
      </section>

      <Divider className="my-16" />

      <section className="bg-[var(--color-emerald-deep)] py-24">
        <div className="mx-auto max-w-6xl px-6 md:px-10">
          <header className="mb-16 max-w-xl">
            <p className="text-[0.7rem] font-medium uppercase tracking-[0.18em] text-[var(--color-sage-light)]/70">
              How We Craft
            </p>
            <h2 className="mt-4 font-serif text-4xl text-[var(--color-cream)] md:text-5xl">
              From nature{" "}
              <em className="font-serif italic text-[var(--color-amber-light)]">
                to you
              </em>
            </h2>
          </header>
          <div className="grid gap-px bg-white/10 md:grid-cols-4">
            {process.map((step) => (
              <article
                key={step.num}
                className="group bg-[var(--color-emerald-deep)] p-10 transition-colors duration-500 hover:bg-[#16291f]"
              >
                <p className="font-serif text-4xl font-light text-[var(--color-cream)]/15">
                  {step.num}
                </p>
                <h3 className="mt-6 font-serif text-2xl text-[var(--color-cream)]">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-[1.7] font-light text-[var(--color-cream)]/55">
                  {step.body}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-6 py-24 text-center md:px-10">
        <span className="eyebrow">A Promise</span>
        <h2 className="mt-6 font-serif text-3xl text-[var(--color-emerald-deep)] md:text-4xl">
          Every candle rests for 48 hours before it reaches you.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-sm leading-[1.85] font-light text-[var(--color-stone)]">
          We believe in the slow work of small fires. Nothing leaves the studio
          until it's been inspected, labelled, and cured — because the moment
          you light it should feel like it was made for you alone.
        </p>
      </section>
    </div>
  );
}
